class TextCarousel {
  constructor(element) {
    this.carousel = element;
    this.items = this.carousel.querySelectorAll('.text-carousel-item');
    this.currentIndex = 0;
    this.totalItems = this.items.length;
    this.interval = 6000; 
  }

  init() {
    this.showItem(this.currentIndex);
    this.startCycle();
  }

  showItem(index) {
    const currentItem = this.items[this.currentIndex];
    const nextItem = this.items[index];

    if (currentItem !== nextItem) {
      currentItem.classList.remove('active');
      nextItem.classList.add('active');
      this.currentIndex = index;
    }
  }

  nextItem() {
    const nextIndex = (this.currentIndex + 1) % this.totalItems;
    this.showItem(nextIndex);
  }

  startCycle() {
    setInterval(() => {
      this.nextItem();
    }, this.interval);
  }
}

const carouselElement = document.getElementById('textCarousel');
if (carouselElement) {
  const textCarousel = new TextCarousel(carouselElement);
  textCarousel.init();
}
